export default __webpack_public_path__ + "static/cloud-cfe99dc94c2124094bf6928fcfb174d5.png";